// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreateAutoresponder_createButton__3k1eP","closeButton":"CreateAutoresponder_closeButton__3Vh5n"};